// Agendas
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista Agendas')),
  route('create', '/create', Form, professionalMeta('Adicionar agenda')),
  route('edit', '/:id/edit', Form, professionalMeta('Editar agenda'))
]

export default subGroup('/agendas', routes)



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/routes.js